<template>
  <section class="container-fluid my-4">
    <h4 class="my-4">Editando <strong>Candidato</strong></h4>

    <div v-if="item">
      <form @submit.prevent="handlerSubmit">
        <div class="row">
          <div class="form-group col-md-6">
            <label for="name">Nome</label>
            <input type="text" class="form-control" id="name" v-model="item.name" />
          </div>
          <div class="form-group col-md-6">
            <label for="phone">Telefone</label>
            <TheMask
              type="text"
              class="form-control"
              id="phone"
              :mask="['(##)#####-####']"
              v-model="item.phone"
              :masked="true"
            />
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-4">
            <label for="city">Cidade</label>
            <input
              type="text"
              class="form-control"
              id="city"
              placeholder="Recife"
              v-model="item.city"
            />
          </div>
          <div class="form-group col-md-2">
            <label for="state">UF</label>
            <select id="state" class="form-control" v-model="item.state">
              <option :value="null" disabled>-- UF --</option>
              <option v-for="uf in brazilianStates" :key="uf.id" :value="uf.id">
                {{ uf.name }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="course_id">Curso</label>
            <select id="course_id" class="form-control" v-model="item.course_id">
              <option disabled value="">-- Selecione --</option>
              <option v-for="course in courses" :key="course.id" :value="course.id">
                {{ course.name }}
              </option>
            </select>
          </div>
          <div class="form-group col-md-3">
            <label for="status">Status</label>
            <select id="status" class="form-control" v-model="item.status">
              <option v-for="option in candidateStatusOptions" :key="option.id" :value="option.id">
                {{ option.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="row">
          <div class="form-group col-md-6">
            <label for="branch_id">Filial</label>
            <select id="branch_id" class="form-control" v-model="item.branch_id">
              <option value="">-- Selecione --</option>
              <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                {{ branch.name }}
              </option>
            </select>
          </div>
        </div>

        <CandidateClosingFields :item="item" />

        <div class="form-group text-center my-2">
          <button type="submit" class="btn btn-success btn-sm mx-2">SALVAR</button>
          <button type="button" class="btn btn-secondary btn-sm" @click="getItem">LIMPAR</button>
        </div>
      </form>

      <button class="btn btn-sm btn-secondary" @click="$router.go(-1)">VOLTAR</button>
    </div>

    <LoadingPage v-else />
  </section>
</template>

<script>
import api from "@/services";
import { errorsToString, candidateStatusOptions, brazilianStates } from "@/helpers";
import LoadingPage from "@/components/LoadingPage.vue";
import CandidateClosingFields from "./CandidateClosingFields.vue";

export default {
  name: "CandidateEdit",
  components: {
    LoadingPage,
    CandidateClosingFields,
  },
  props: ["id"],
  data() {
    return {
      candidateStatusOptions,
      brazilianStates,
      courses: [],
      branches: [],
      item: null,
    };
  },
  methods: {
    async getBranches() {
      const { data } = await api.get("/branches?perPage=99999");
      this.branches = data.data;
    },
    async getCourses() {
      const { data } = await api.get("/courses?page=1&perPage=99999");
      this.courses = data.data;
    },
    async getItem() {
      try {
        const { data } = await api.get(`/candidates/${this.id}`);
        this.item = { ...data[0], branch_id: data[0].branch_id || "" };
      } catch (error) {
        const message = error.response && error.response.data && error.response.data.message;
        Toast.fire(message || "Candidato não encontrado.", "", "error");
        this.$router.push({ name: "candidates" });
      }
    },
    async handlerSubmit() {
      const form = {
        name: this.item.name,
        phone: this.item.phone,
        city: this.item.city,
        state: this.item.state,
        course_id: this.item.course_id,
        status: this.item.status,
        branch_id: this.item.branch_id || null,
        proposal_date: this.item.proposal_date,
        proposal_value: this.item.proposal_value,
        closing_type: this.item.closing_type,
        closing_date: this.item.closing_date,
        closing_value: this.item.closing_value,
        payment_type_id: this.item.payment_type_id,
        card_holder: this.item.card_holder,
        card_last_digits: this.item.card_last_digits,
        amount_paid: this.item.amount_paid,
        bank: this.item.bank,
        paid_off: this.item.paid_off,
        service_sent: this.item.service_sent,
        service_date: this.item.service_date,
      };

      try {
        const { data } = await api.put(`/candidates/${this.id}`, form);
        Toast.fire(data.message, "", "success");
        this.$router.push({ name: "candidates" });
      } catch (error) {
        const errors = error.response && error.response.data && error.response.data.errors;
        Toast.fire(errors ? errorsToString(errors) : "Não foi possível salvar o candidato.", "", "error");
      }
    },
  },
  async mounted() {
    await this.getCourses();
    this.getBranches();
    this.getItem();
  },
};
</script>
